export default {
    name: 'reportReviewService',
    dependencies: ['xhrservice'],
    callable(xhrservice) {
        function postReviewComplaint(reviewId, complaintReason) {
            const url = `/review/report-review.html?reviewId=${reviewId}`;
            return xhrservice.request({
                url,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: JSON.stringify({
                    complaint: complaintReason,
                    reviewId,
                }),
            });
        }

        return {
            postReviewComplaint,
        };
    },
};



// WEBPACK FOOTER //
// ./services/reportReview.js